import React from 'react';
import Numpad from './Numpad';
import DateChip from '../components/DateChip';
import './NumpadApiLayout.css';

const NumpadApiLayout = ({
  points,
  setPoints,
  selectedGameType,
  setSelectedGameType,
  handleNumpadApiClick,
  fetchedDigits,
  isLoading,
  showSessionSelector,
  openBidDisabled,
}) => (
  <div className="numpad-api-layout">
    <DateChip />
    {showSessionSelector && (
      <div className="input-row session-row">
        <label>Select Game Type:</label>
        <select
          className="beautiful-select dropdown-select"
          value={selectedGameType}
          onChange={(e) => setSelectedGameType(e.target.value)}
          disabled={isLoading}
        >
          {!openBidDisabled && <option value="Open">Open</option>}
          <option value="Close">Close</option>
        </select>
      </div>)}
    <div className="input-row points-row">
      <label>Enter Points:</label>
      <input
        type="tel"
        value={points}
        onChange={(e) => setPoints(e.target.value.replace(/[^0-9]/g, ''))}
        placeholder="Enter Amount"
        disabled={isLoading}
        className="beautiful-input"
      />
    </div>
    <div className="numpad-wrapper">
      <Numpad
        onNumberClick={handleNumpadApiClick}
        // fetchedDigits={fetchedDigits}
        isLoading={isLoading}
      />
    </div>
  </div>
);

export default NumpadApiLayout;